import { Dropdown } from '@mgmresorts/mgm-ui';
import React, { useContext, useEffect, useMemo, useState } from 'react';

import { useContent } from '../../../hooks/useContent';
import { isValidAge } from '../../../utils/validators';
import { SignUpFormContext } from '../SignUpFormContext';
import { useFieldErrorAnalytics } from '../useFieldErrorAnalytics';

import { StyledBirthdayHint, StyledContainer } from './styles';

export function BirthdayExtendedInput() {
  const { birthDate, bindBirthMonth, birthMonth, bindBirthYear, birthYear, bindBirthDate, isLoading } =
    useContext(SignUpFormContext);
  const { getContentByPath } = useContent();
  const [invalidFields, setInvalidFields] = useState<string[]>([]);
  useFieldErrorAnalytics({ field: 'birthday', invalidFields });

  const months = useMemo(
    () =>
      new Array(12).fill(true).map((_, i) => ({
        value: `${i + 1}`,
        text: getContentByPath(`accountCreation.fields.birthday.months['${i + 1}']`) as string,
      })),
    [getContentByPath],
  );
  const days = useMemo(
    () =>
      new Array(new Date(Number(birthYear) || 4, Number(birthMonth) || 1, 0).getDate()).fill(true).map((_, i) => ({
        value: `${i + 1}`,
        text: `${i + 1}`,
      })),
    [birthMonth, birthYear],
  );
  const years = useMemo(() => {
    const max = new Date().getFullYear() - 21;
    const min = 1900;
    const result: { value: string; text: string }[] = [];
    for (let i = max; i >= min; i--) {
      result.push({ value: `${i}`, text: `${i}` });
    }
    return result;
  }, []);

  const error = useMemo(
    () =>
      birthDate && birthMonth && birthYear && !isValidAge(`${birthMonth}/${birthDate}/${birthYear}`)
        ? (getContentByPath('accountCreation.fields.birthday.error') as string)
        : undefined,
    [birthDate, birthMonth, birthYear, getContentByPath],
  );

  useEffect(() => {
    const maxDate = Number(days[days.length - 1].value);
    if (birthDate && Number(birthDate) > maxDate) {
      bindBirthDate.onChange(`${maxDate}`);
    }
    if (birthDate && birthMonth && birthYear && !isValidAge(`${birthMonth}/${birthDate}/${birthYear}`)) {
      setInvalidFields(['birthday']);
    } else {
      setInvalidFields([]);
    }
  }, [bindBirthDate, birthDate, birthMonth, birthYear, days]);

  return (
    <div>
      <StyledContainer>
        <Dropdown
          id='birthMonth'
          testId='birthMonth'
          placeholder={getContentByPath('accountCreation.fields.birthday.months.label')}
          options={months}
          disabled={isLoading}
          {...bindBirthMonth}
          onChange={e => bindBirthMonth.onChange(e.target.value)}
        />
        <Dropdown
          id='birthDate'
          testId='birthDate'
          placeholder={getContentByPath('accountCreation.fields.birthday.days.label')}
          options={days}
          disabled={isLoading}
          {...bindBirthDate}
          onChange={e => bindBirthMonth.onChange(e.target.value)}
        />
        <Dropdown
          id='birthYear'
          testId='birthYear'
          placeholder={getContentByPath('accountCreation.fields.birthday.years.label')}
          options={years}
          disabled={isLoading}
          {...bindBirthYear}
          onChange={e => bindBirthMonth.onChange(e.target.value)}
        />
      </StyledContainer>
      <StyledBirthdayHint variant='body-regular-s' testId='birthDay__message' className='with-error'>
        {error || getContentByPath('accountCreation.fields.birthday.hint')}
      </StyledBirthdayHint>
    </div>
  );
}
